import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DeleteIcon from '@/assets/refund/bin.png';
import CustomModal from '../common/CustomModal';
import { useMutation, useQueryClient } from 'react-query';
import { refundCancle } from '@/api/refund';
import { AxiosError } from 'axios';
import { IRefundCanclePayload, IRefundDetailContent } from '@/types/refund';
import NonCancellableModal from '../refundDetail/NonCancellableModal';
import FlexWrap from '../common/FlexWrap';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { convertToKoreanUnit, getComma } from '@/util/format';
import RefundCancelCompleteModal from '../refundDetail/RefundCancelComplete.modal';
import { format } from 'date-fns';
import PaymentCancelModal from './PaymentCancel.modal';
import { usePatchCancelPayment } from '@/hooks/usePostCancelPayment';
import { useGetPaymentStatusForCancel } from '@/hooks/useGetPaymentStatusForCancel';
import PaymentCancelInfoModal from './PaymentCancelInfo.modal';
import RefundInfoCard from '../refund/RefundInfoCard';
import { getPaymentLogoImage } from '@/util/payment';
import PaymentCancelCompleteModal from './PaymentCancelComplete.modal';
import PaymentCancelErrorModal from './PaymentCancelError.modal';
type Props = {
  refund: IRefundDetailContent;
  isCanceled?: boolean;
  isCancelDisable?: boolean;
};
function GlobalPaymentAndRefundCancelButton({
  refund,
  isCanceled,
  isCancelDisable,
}: Props) {
  const {
    nation,
    paymentType,
    refund: refundPrice,
    refundIndex,
    supplyDate,
    totalPrice,
    touristPassportNumber,
    qrOrderId,
  } = refund;
  const queryClient = useQueryClient();

  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const [isOpenNonCancelledModal, setIsOpenNonCancelledModal] = useState(false);
  const [isOpenCompleteModal, setIsOpenCompleteModal] = useState(false);
  const { isAutoPayment, hospitalId } = useAppSelector((state) => state.user);
  const [isPaymentCancelModalOn, setIsPaymentCancelModalOn] = useState(false);
  const [isPaymentCancelErrorModalOn, setIsPaymentCancelErrorModalOn] =
    useState(false);

  const [isPaymentCancelLoading, setIsPaymentCancelLoading] = useState(false);
  const [isPaymentCancelCompleteModalOn, setIsPaymentCancelCompleteModalOn] =
    useState(false);
  const [isPaymentCancelInfoModalOn, setIsPaymentCancelInfoModalOn] =
    useState(false);
  const { paymentStatus, checkPaymentStatus, isLoading } =
    useGetPaymentStatusForCancel({
      qrOrderId: qrOrderId?.toString(),
    });
  const { cancelPaymentAsync } = usePatchCancelPayment({
    onSuccess: () => {
      setIsPaymentCancelModalOn(false);
    },
    onError: (error) => {
      console.log('결제 취소 에러:', error);
    },
  });

  const refundCancelMutation = useMutation<
    null,
    AxiosError,
    IRefundCanclePayload
  >('refundCancel', (payload) => refundCancle(payload), {
    retry: false,
    onSuccess: () => {
      setIsDisabledButton(false);
      onOpenDeleteModal();
      setIsOpenCompleteModal(true);
      queryClient.invalidateQueries('refundDetail');
    },
    onError: (error) => {
      if ((error.response as any).data.code === 'R0012') {
        setIsOpenNonCancelledModal(true);
        onCloseDeleteModal();
      }

      setIsDisabledButton(false);
      console.log('에러', error);
    },
  });

  const onOpenDeleteModal = async () => {
    if (qrOrderId) {
      const res = await checkPaymentStatus();
      console.log('결제 상태 확인 결과:', res);
      setIsPaymentCancelInfoModalOn(true);
    } else {
      setIsDeleteModal((prev) => !prev);
    }
  };
  const onClickRefundCancel = () => {
    setIsDisabledButton(true);
    refundCancelMutation.mutate({ cancelList: [refundIndex] });
  };

  const handleCloseCompleteModal = () => {
    queryClient.invalidateQueries('refundDetail');
    setIsOpenCompleteModal(false);
  };

  const handleClosePaymentCancelModal = () => {
    setIsPaymentCancelCompleteModalOn(false);
  };

  const handlePaymentCancel = async () => {
    try {
      setIsPaymentCancelLoading(true);

      await cancelPaymentAsync({
        requestType: 'MEDICAL_USER',
        hospitalId: hospitalId,
        qrOrderIndex: qrOrderId,
      });
      queryClient.invalidateQueries('paymentDetail');
      queryClient.invalidateQueries('refundDetail');
      setIsPaymentCancelCompleteModalOn(true);
    } catch (error) {
      console.error('결제 취소 에러:', error);
    } finally {
      setIsPaymentCancelLoading(false);
    }
  };

  const onCloseDeleteModal = async () => {
    setIsPaymentCancelInfoModalOn(false);
  };

  const renderModalContent = () => (
    <PaymentCancelInfoContainer dir='column'>
      <ContentRow>
        <ContentName>거래 일시</ContentName>
        {format(
          new Date(paymentStatus?.createdDate || Date.now()),
          'yyyy.MM.dd HH:mm',
        )}
      </ContentRow>
      <ContentRow>
        <ContentName>결제 방법</ContentName>
        <img
          src={getPaymentLogoImage(paymentStatus?.qrOrderAgent ?? '')}
          alt={`${paymentStatus?.qrOrderAgent} 로고`}
          height={20}
        />
      </ContentRow>

      {paymentStatus?.refundInfo && (
        <RefundInfoCard
          nationality={paymentStatus?.refundInfo?.nation}
          passportNumber={paymentStatus?.refundInfo?.passportNumber}
          totalAmount={Number(paymentStatus?.refundInfo?.totalAmount)}
          refundAmount={Number(paymentStatus?.refundInfo?.refundAmount)}
          qrPaymentAmount={Number(paymentStatus?.refundInfo?.qrPaymentAmount)}
          paymentAmount={Number(paymentStatus?.refundInfo?.paymentAmount)}
        />
      )}
    </PaymentCancelInfoContainer>
  );
  return (
    <>
      {!isCanceled && (
        <DeleteBtn
          onClick={() => {
            if (isCancelDisable) {
              setIsPaymentCancelErrorModalOn(true);
            } else {
              onOpenDeleteModal();
            }
          }}
          isCancelDisable={isCancelDisable}
        >
          <DeleteImg src={DeleteIcon} />
        </DeleteBtn>
      )}
      {/* 환급/결제 취소 로직 */}
      {isPaymentCancelInfoModalOn && !isLoading && (
        <PaymentCancelInfoModal
          title={'환급과 해외 간편 결제가 함께 취소됩니다'}
          cancelAmount={convertToKoreanUnit(
            Number(paymentStatus?.qrOrderPaymentAmount),
          )}
          btnTitle='다음'
          subBtnTitle='취소'
          onClickSubBtn={onCloseDeleteModal}
          onClickBtn={() => {
            setIsPaymentCancelModalOn(true);
            setIsPaymentCancelInfoModalOn(false);
          }}
          contentElement={renderModalContent()}
        />
      )}
      <PaymentCancelModal
        isOpen={isPaymentCancelModalOn}
        title={'결제 및 환급건 취소하기'}
        desc={'결제와 환급을 취소할까요?'}
        subBtnTitle='취소'
        onClickSubBtn={() => {
          setIsPaymentCancelModalOn(false);
        }}
        btnTitle='결제 취소하기'
        isBtnLoading={isPaymentCancelLoading}
        onClickBtn={handlePaymentCancel}
      />
      <PaymentCancelErrorModal
        isOpen={isPaymentCancelErrorModalOn}
        desc={
          '해당 건은 환급금 수령이 완료되어 직접 취소가 불가합니다.\n취소를 원하시면 채팅 혹은 전화로 문의 부탁드립니다.'
        }
        onClose={() => {
          setIsPaymentCancelErrorModalOn(false);
        }}
      />
      {isPaymentCancelCompleteModalOn && (
        <PaymentCancelCompleteModal
          title='결제 및 환급 취소되었습니다'
          cancelDate={format(new Date(), 'yyyy.MM.dd HH:mm')}
          cancelAmount={convertToKoreanUnit(
            Number(paymentStatus?.qrOrderPaymentAmount),
          )}
          paymentDate={format(
            new Date(paymentStatus?.createdDate || Date.now()),
            'yyyy.MM.dd HH:mm',
          )}
          nationality={paymentStatus?.refundInfo?.nation}
          passportNumber={paymentStatus?.refundInfo?.passportNumber}
          totalAmount={Number(paymentStatus?.refundInfo?.totalAmount)}
          refundAmount={Number(paymentStatus?.refundInfo?.refundAmount)}
          paymentMethod={paymentStatus?.qrOrderAgent}
          btnTitle='확인'
          onClickBtn={handleClosePaymentCancelModal}
        />
      )}
      {/*환급만 취소 로직 */}
      {isDeleteModal && (
        <Wrapper>
          <CustomModal
            title='환급건 취소하기'
            desc='환급을 취소할까요?'
            btnTitle='취소하기'
            subBtnTitle='닫기'
            btnDisabled={isDisabledButton}
            onClickSubBtn={onOpenDeleteModal}
            onClickBtn={onClickRefundCancel}
            mainBtnColor={'#FF2D55'}
            contentElement={
              <ContentContainer dir='column'>
                시술일자 {supplyDate}
                <br />
                국적 {nation}
                <br />
                결제 금액
                {isAutoPayment
                  ? getComma(
                      paymentType === 'ORIGINAL'
                        ? +totalPrice - +refundPrice
                        : +totalPrice,
                    )
                  : getComma(totalPrice)}
                원
                <br />
                환급액 {getComma(refundPrice)}원
              </ContentContainer>
            }
          />
        </Wrapper>
      )}
      {isOpenNonCancelledModal && (
        <NonCancellableModal
          isOpen={isOpenNonCancelledModal}
          onClose={() => setIsOpenNonCancelledModal(false)}
        />
      )}
      {isOpenCompleteModal && (
        <RefundCancelCompleteModal
          cancelDate={format(new Date(), 'yyyy.MM.dd HH:mm')}
          paymentDate={format(new Date(supplyDate), 'yyyy.MM.dd')}
          nationality={nation}
          passportNumber={touristPassportNumber}
          totalAmount={Number(totalPrice)}
          refundAmount={Number(refundPrice)}
          totalPrice={convertToKoreanUnit(
            paymentType === 'ORIGINAL'
              ? Number(totalPrice) - Number(refundPrice)
              : Number(totalPrice),
          )}
          btnTitle='확인'
          onClickBtn={handleCloseCompleteModal}
        />
      )}
    </>
  );
}
export default GlobalPaymentAndRefundCancelButton;
const DeleteImg = styled.img`
  width: 18px;
  height: 18px;
`;
const DeleteBtn = styled.button<{ isCancelDisable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  opacity: ${(props) => (props.isCancelDisable ? 0.17 : 1)};

  &:hover {
    border-color: ${(props) =>
      !props.isCancelDisable ? '#e9f0fe' : 'transparent'};
    background-color: ${(props) =>
      !props.isCancelDisable ? '#e9f0fe' : 'transparent'};
  }
`;

const ContentContainer = styled(FlexWrap)`
  background-color: ${(props) => props.theme.mono[5]};
  border-radius: 4px;
  padding: 12px;
  color: ${(props) => props.theme.mono[65]};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  text-align: left;
  color: #030303;
`;
const PaymentCancelInfoContainer = styled(FlexWrap)`
  padding-top: 24px;
  gap: 12px;
`;

const ContentRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #3a3b3e;
  text-align: right;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const ContentName = styled.div`
  color: #80848a;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;
